<template>
  <div>
    <div class="text-subtitle-4 neutral-040--text mb-3 d-flex align-center">
      <v-btn
        icon
        small
        target="_blank"
        class="mr-1"
        :href="omnichatDocs + 'features/omo-she-ding/dian-yuan-pai-ban-guan-li#dian-yuan-xun-xi-she-ding'"
      >
        <v-icon color="neutral-044">
          mdi-help-circle
        </v-icon>
      </v-btn>
      {{ $t('STAFF_MANAGEMENT.STAFF_MESSAGING_SETTING') }}
    </div>
    <div class="d-flex justify-space-between pt-4 pb-1 messaging-setting-item">
      <div class="mr-3">
        {{ $t('STAFF_MANAGEMENT.ENABLE_FORCE_OFFLINE') }}
      </div>
      <div>
        <v-switch
          v-model="teamSetting.enableForceOffline"
          @change="handleTeamSettingToggle(SETTING_TYPE.ENABLE_FORCE_OFFLINE, teamSetting.enableForceOffline)"
          inset
          class="custom-switch messaging-setting-switch mt-0 pt-0"
          color="secondary-014"
          :loading="toggleType === SETTING_TYPE.ENABLE_FORCE_OFFLINE"
        />
      </div>
    </div>
    <div class="d-flex justify-space-between pt-4 pb-1 messaging-setting-item">
      <div class="mr-3">
        {{ $t('STAFF_MANAGEMENT.SKIP_NOTIFY_WHEN_OFFLINE') }}
      </div>
      <div>
        <v-switch
          v-model="teamSetting.skipNotifyWhenOffline"
          @change="handleTeamSettingToggle(SETTING_TYPE.SKIP_NOTIFY_WHEN_OFFLINE, teamSetting.skipNotifyWhenOffline)"
          inset
          class="custom-switch messaging-setting-switch mt-0 pt-0"
          color="secondary-014"
          :loading="toggleType === SETTING_TYPE.SKIP_NOTIFY_WHEN_OFFLINE"
        />
      </div>
    </div>
    <div class="d-flex justify-space-between pt-4 pb-1 messaging-setting-item">
      <div class="mr-3">
        {{ $t('STAFF_MANAGEMENT.NOTIFY_MANAGER_WHEN_OFFLINE') }}
      </div>
      <div>
        <v-switch
          v-model="teamSetting.notifyManagerWhenOffline"
          @change="handleTeamSettingToggle(SETTING_TYPE.NOTIFY_MANAGER_WHEN_OFFLINE, teamSetting.notifyManagerWhenOffline)"
          inset
          class="custom-switch messaging-setting-switch mt-0 pt-0"
          color="secondary-014"
          :loading="toggleType === SETTING_TYPE.NOTIFY_MANAGER_WHEN_OFFLINE"
        />
      </div>
    </div>
    <div class="d-flex justify-space-between pt-4 pb-1 messaging-setting-item">
      <div class="mr-3">
        {{ $t('STAFF_MANAGEMENT.DISABLE_MESSAGING_WHEN_OFFLINE') }}
      </div>
      <div>
        <v-switch
          v-model="teamSetting.disableMessagingWhenOffline"
          @change="handleTeamSettingToggle(SETTING_TYPE.DISABLE_MESSAGING_WHEN_OFFLINE, teamSetting.disableMessagingWhenOffline)"
          inset
          class="custom-switch messaging-setting-switch mt-0 pt-0"
          color="secondary-014"
          :loading="toggleType === SETTING_TYPE.DISABLE_MESSAGING_WHEN_OFFLINE"
        />
      </div>
    </div>
    <Notification
      ref="notification"
    />
  </div>
</template>
<script>
import { mapState } from 'vuex';
import commonApi from '@/restapis/common';

export default {
  name: 'StaffMessagingSetting',
  components: {
  },
  props: {

  },
  data() {
    return {
      SETTING_TYPE: {
        SKIP_NOTIFY_WHEN_OFFLINE: 'skip-notify-when-offline',
        NOTIFY_MANAGER_WHEN_OFFLINE: 'notify-manager-when-offline',
        ENABLE_FORCE_OFFLINE: 'enable-force-offline',
        DISABLE_MESSAGING_WHEN_OFFLINE: 'disable-messaging-when-offline'
      },
      teamSetting: {
        skipNotifyWhenOffline: false, // (店員離線/休假時，收到客人有新 Message，不通知店員)
        notifyManagerWhenOffline: false, // (店員離線/休假時，收到客人有新 Message，通知分店經理) 已存在
        enableForceOffline: false, // (按店員班表強制店員下班後/休假時離線)
        disableMessagingWhenOffline: false // (禁止休假店員傳訊息給客人)
      },
      toggleType: '',
      omnichatDocs: this.$t('OMNICHAT_DOCS')
    };
  },
  computed: {
    ...mapState({
      currentUserDict: (state) => state.currentUserDict
    })
  },
  methods: {
    getTeamMessagingSetting() {
      this.teamSetting = {
        skipNotifyWhenOffline: this.currentUserDict.skipNotifyWhenOffline,
        notifyManagerWhenOffline: this.currentUserDict.notifyManagerWhenOffline,
        enableForceOffline: this.currentUserDict.enableForceOffline,
        disableMessagingWhenOffline: this.currentUserDict.disableMessagingWhenOffline
      };
    },
    async handleTeamSettingToggle(type, value) {
      this.toggleType = type;
      try {
        const response = await commonApi.team.updateTeamSetting(type, value);

        if (response.status === 200) {
          const notificationObj = {
            title: this.$t('STAFF_MANAGEMENT.SETUP_HAS_BEEN_CHANGED'),
            status: 'success'
          };
          this.$refs.notification.openNotification(notificationObj);
          this.toggleType = '';
        }
      } catch (error) {
        console.log(error.response.data);
        const notificationObj = {
          title: this.$t('UPDATE_FAILS'),
          content: error.response.message
        };
        this.$refs.notification.openNotification(notificationObj);
        this.getTeamMessagingSetting();
        this.toggleType = '';
      }
    }
  },
  mounted() {
    this.getTeamMessagingSetting();
  }
};
</script>

<style lang="scss" scoped>
.messaging-setting-item {
  border-bottom: 1px solid $neutral-cold-056;
}

::v-deep.messaging-setting-switch {
  .v-messages {
    display: none;
  }
}
</style>
